import React, { useState } from 'react';
import Header from './components/HeaderAdmin.js';
import Main from './components/Main';
import LeftContainerAdmin from './components/LeftContainerAdmin';
import RightContainer from './components/RightContainer';
import { Navigate } from 'react-router-dom';

function AdminApp() {
    const [filteredEventDates, setFilteredEventDates] = useState([]);
    var role = localStorage.getItem('role');

    switch (role) {
        case 'Visit Requester':
        case 'Requester':
            return (
                <div>
                    <Navigate to={`/AppRequester`} replace />
                </div>
            )
        case 'MLTUser':
        case 'MLTCoordinator':
            return (
                <Navigate to={`/AppMltEvent`} replace />
            )
        case 'Admin':
            return (
                <div>
                    <Header />
                    <Main />
                    {/* <Navbar /> */}
                    <div className="container-fluid">
                        <div className="progress d-flex flex-column" style={{ backgroundColor: 'gainsboro', height: '100%' }}>
                            <div className="row">
                                <div className="col-md-8">
                                    <LeftContainerAdmin setFilteredEventDates={setFilteredEventDates} />
                                </div>
                                <div className="col-md-4">
                                    <RightContainer eventDates={filteredEventDates} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        case 'Family':
        case 'FamilyCoordinator':
            return (
                <div>
                    <Navigate to={`/AppFamily`} replace />
                </div>
            )
        default:
            return (
                <div>
                    <Navigate to="/" replace />
                </div>
            )
    }
}
export default AdminApp;      